import { CallbackObject } from "api/core/get-page-function";
import { instance } from "api/core";

export interface SetReplenishmentThresholdBody {
    locationId: string;
    productId: string;
    min: number;
    max: number;
}

export const setReplenishmentThreshold = async (warehouseId: string, body: SetReplenishmentThresholdBody, callback: CallbackObject<void>) => {
    try {
        await instance.post(`/replenishment/warehouses/${warehouseId}/thresholds`, body);
        callback.success();
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};
